/* eslint-disable multiline-ternary */
import { Button, ConfirmModal, Loader, Modal, Typography } from 'src/components/common';
import * as Yup from 'yup';
import './hiringdetail.scss';
import Label from 'src/components/common/formFields/label/Label';
import { InputField } from 'src/components/common/formFields';
import TextArea from 'src/components/common/formFields/textArea/TextArea';
import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import ErrorMessage from 'src/components/common/formFields/errorMessage/ErrorMessage';
import { TFindCreateConversationRequest, TGetChatFilePresignedUrlActionRequest, TGetChatFilePresignedUrlResponse, TSendDirectMessageRequest, TUploadChatFileToS3ActionRequest, TUploadChatFileToS3Request, TUploadChatFileToS3Response } from 'src/services/apiEndpoint.types.ts';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useGetIdentity, useUploadMedia, useUrlParamValue } from 'src/hooks';
import { findCreateConversation, getChatFilePresignedUrl, sendDirectMessage, uploadChatFile } from 'src/store/chat/chat.slice';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import UploadField from '../upload-field/UploadField';
import { APIResponse } from 'src/services/base.api.service';
import { ChatAPIService } from 'src/services/chat.api.service';
import FileCard from 'src/components/chat/fileCard/FileCard';
interface THiringDetailModalProps {
    title: string;
    isModalOpen: boolean;
    handleCloseModal: () => void;
    detail: any;
    userId?: string | null,
    companyId?: string | null
}
const validationSchema = Yup.object().shape({
    subject: Yup.string().required('subject is required'),
    message: Yup.string().required('message is required')
});
const HiringDetailModal = ({ isModalOpen, handleCloseModal, title, detail, userId, companyId }: THiringDetailModalProps) => {
    // hooks 
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { handleUploadMedia } = useUploadMedia();
    const { getIdentities } = useGetIdentity();
    const { paramValue } = useUrlParamValue();
    const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);

    // state 
    const [step, setStep] = useState<string>('view');
    const [errorTrig, setErrorTrig] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [uploadData, setUploadData] = useState({
        messageId: uuidv4(),
        id: uuidv4(),
        fileData: null,
        fileName: '',
        conversationId: ''
    })

    // Constants
    const id: string = paramValue({ paramName: 'id' }) as string;
    const date = detail?.createdAt ? new Date(detail?.createdAt).toISOString().split('T')[0] : '';
    const { authenticatedId, loggedInUserType, loggedInCompanyId } = getIdentities();
    const modifiedTitle = step === 'view' ? title : `Apply for ${detail?.title}`;
    const initialValues = {
        subject: `Application for ${detail?.title}`,
        message: '',
        file: ''
    }

    // handler
    function handleNavigate() {
        navigate(`/login?prev=${encodeURIComponent(`/view-venture?id=${id}`)}`)
    }
    const onMediaLoad = (
        data: string | ArrayBuffer | null,
        fileType: string,
        mediaType: string,
        name: string,
        size: number
    ) => {
        setUploadData({
            ...uploadData,
            fileName: name,
            fileData: data
        })
    };

    const chatToUser = (formdata) => {
        if (!isAuthorized) {
            setShow(true)
            return
        }
        setErrorTrig(false);
        if (!uploadData?.fileData) {
            setErrorTrig(true)
            return
        }

        const payload: TFindCreateConversationRequest = {
            senderUserId: authenticatedId,
            senderUserType: loggedInUserType,
            receiverUserId: userId || companyId,
            receiverUserType: companyId ? 'Company' : 'User',
            ...(companyId ? { moduleType: 'ServiceProvider' } : { moduleType: 'General' })
        };
        setLoading(true)
        dispatch(findCreateConversation(payload)).then(async (data) => {
            const conversationId = data?.conversation?.id;
            const id = uuidv4()
            if (conversationId) {
                if (uploadData?.fileData) {
                    const uploadPayload = {
                        fileName: uploadData.fileName,
                        messageId: id,
                        id,
                        conversationId
                    }
                    const { status, data }: APIResponse<TGetChatFilePresignedUrlResponse> =
                        await new ChatAPIService().getChatFilePresignedUrl(uploadPayload);
                    if (status === 200 && data?.data) {
                        const uploadFilePayloadRequest: TUploadChatFileToS3Request = {
                            signedUrl: data?.data,
                            fileData: uploadData?.fileData
                        };
                        const { status }: APIResponse<TUploadChatFileToS3Response> =
                            await new ChatAPIService().uploadChatFile(uploadFilePayloadRequest);
                        if (status === 200) {
                            const payload: TSendDirectMessageRequest = {
                                userId: authenticatedId,
                                userType: loggedInUserType,
                                conversationId,
                                eventName: 'conversation',
                                message: `${formdata?.subject} : ${formdata?.message}`,
                                messageId: id,
                                files: uploadData ? [{ id, fileName: uploadData?.fileName }] : []
                            };
                            dispatch(sendDirectMessage(payload));
                            if (conversationId) {
                                const path = `/chat?conversationId=${conversationId}&userType=${companyId ? 'Company' : 'User'}&userId=${userId}&prev=/view-venture?id=${id}`;
                                navigate(path);
                            }
                        }
                    }
                } else {
                    const payload: TSendDirectMessageRequest = {
                        userId: authenticatedId,
                        userType: loggedInUserType,
                        conversationId,
                        eventName: 'conversation',
                        message: `${formdata?.subject} : ${formdata?.message}`,
                        messageId: id,
                        files: uploadData ? [{ id, fileName: uploadData?.fileName }] : []
                    };
                    dispatch(sendDirectMessage(payload));
                    if (conversationId) {
                        const path = `/chat?conversationId=${conversationId}&userType=${companyId ? 'Company' : 'User'}&userId=${userId}&prev=/view-venture?id=${id}`;
                        navigate(path);
                    }
                }
            }
        }
        ).finally(() => {
            setLoading(false)
        })
    }
    function handleSubmit(data) {
        chatToUser(data)
    }
    return (
        <>
            <ConfirmModal
                title=""
                description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
                    <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
                    <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
                </p>}
                openConfirmModal={show}
                onClose={() => setShow(false)}
                onSubmit={handleNavigate}
                submitText="Sign in"
                type="confirm"
            />
            {!show && <Modal
                isModalOpen={isModalOpen}
                onModalClose={handleCloseModal}
                title={modifiedTitle}
                className="hiringDetail"
            >
                {step === 'view' && <>
                    <InputField title={detail?.title} label='Title' onChange={() => { }} value={detail?.title} type='text' id='title' readOnly disabled />
                    <InputField title={date} label='Posted Date' onChange={() => { }} value={date} type='date' id='date' readOnly disabled />
                    <InputField title={detail?.domain} label='Domain' onChange={() => { }} value={detail?.domain} type='text' id='domain' readOnly disabled />
                    {detail.description && <>
                        <Label>Description</Label>
                        <TextArea textAreaStyle={{ width: '100%' }} disabled readOnly>
                            {detail?.description}
                        </TextArea>
                    </>}
                    {(loggedInUserType === 'Company' ? authenticatedId !== companyId : authenticatedId !== userId) && <Button size='small' onClick={() => setStep('apply')}>Apply</Button>}
                </>}

                {step === 'apply' &&
                    (
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize>
                            {({ setFieldValue, values, resetForm, errors, touched }) => {
                                return (
                                    <Form>
                                        <InputField label='Subject' onChange={() => { }} value={values.subject} type='text' id='Subject' readOnly disabled />
                                        <Label>Message <span style={{ color: 'red' }}>*</span></Label>
                                        <TextArea textAreaStyle={{ width: '100%' }} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFieldValue('message', e.target.value)}>
                                            {values.message}
                                        </TextArea>
                                        {errors.message && touched.message && <ErrorMessage message={'this field is required'} />}
                                        <div className='uploadFileld'>
                                            {!uploadData.fileData && <UploadField required accept=".pdf, .docx, .doc, .xls, .xlsx," title={`Attach File`} instructionText='' onUpload={(data, e) => {
                                                handleUploadMedia({ e, onLoad: onMediaLoad, mediaType: 'program' });
                                            }} />}
                                            {uploadData.fileData && <FileCard
                                                key=''
                                                s3Key={''}
                                                showDeleteButton={true}
                                                showDownloadButton={false}
                                                id={id}
                                                fileName={uploadData.fileName}
                                                onRemove={() => setUploadData({
                                                    messageId: uuidv4(),
                                                    id: uuidv4(),
                                                    fileData: null,
                                                    fileName: '',
                                                    conversationId: ''
                                                })}

                                            />}
                                            {errorTrig && !uploadData?.fileData && <ErrorMessage message={'this field is required'} />}
                                        </div>
                                        <div className='d-flex gap-3'>
                                            <Button style={{ marginTop: '10px' }} variant='secondary' size='small' onClick={handleCloseModal}>Cancel</Button>
                                            <Button style={{ marginTop: '10px' }} type='submit' size='small' disabled={loading}>
                                                {loading ? <Loader /> : 'Submit'}
                                            </Button>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    )}
            </Modal>}
        </>
    );
};

export default HiringDetailModal;
